$(document).on('click', 'button[name=apply_promocode]', function(e){
  e.preventDefault();

  var promocode = $('input[name=promocode]').val();
  var language = $('input[name=promocode]').data('language');
  var csrf      = $('input[name=_token]').val();

  var data = {
    promocode: promocode,
    _token: csrf
  }

  $.ajax({
    url: '/'+language+'/apply-promocode',
    data: data,
    type: 'post',
    dataType: 'json',
    success: function(data){

      $('#promo-notify').html(data.response.text);

      if (data.response.code == 'ok') {
        setTimeout(function(){
          location.reload();
        },3000)
      }
    }
  })

  console.log(data);
})



$(document).on('click', 'button[name=cancel_promocode]', function(e){
  e.preventDefault();

  var csrf      = $('input[name=_token]').val();
  var language = $('input[name=promocode]').data('language');

  var data = {
    _token: csrf
  }


  $.ajax({
    url: '/'+language+'/cancel-promocode',
    data: data,
    type: 'post',
    success: function(data){
      location.reload();
    }
  })

})
